import { render, staticRenderFns } from "./SaveVorlageDialog.vue?vue&type=template&id=6c44aceb&scoped=true"
import script from "./SaveVorlageDialog.vue?vue&type=script&lang=js"
export * from "./SaveVorlageDialog.vue?vue&type=script&lang=js"
import style0 from "./SaveVorlageDialog.vue?vue&type=style&index=0&id=6c44aceb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c44aceb",
  null
  
)

export default component.exports